[
  {
    "title": "Guide",
    "pages": [
      {
        "href": "/docs/guide/intro",
        "title": "Introduction to Modal"
      },
      {
        "href": "/docs/guide/getting-started",
        "title": "Getting started"
      }
    ]
  },
  {
    "title": "Functions",
    "pages": [
      {
        "href": "/docs/guide/functions",
        "title": "Functions"
      },
      {
        "href": "/docs/guide/function-invocation-methods",
        "title": "Invocation methods"
      },
      {
        "href": "/docs/guide/trigger-deployed-functions",
        "title": "Function lookups"
      },
      {
        "href": "/docs/guide/lifecycle-functions",
        "title": "Container lifecycle management"
      },
      {
        "href": "/docs/guide/parametrized-functions",
        "title": "Parametrized Functions"
      },
      {
        "href": "/docs/guide/dynamic-function-config",
        "title": "Dynamic configuration"
      }
    ]
  },
  {
    "title": "Sandboxes",
    "pages": [
      { "href": "/docs/guide/sandboxes", "title": "Sandboxes" },
      { "href": "/docs/guide/sandbox-spawn", "title": "Running commands" },
      {
        "href": "/docs/guide/sandbox-networking",
        "title": "Networking and security"
      },
      { "href": "/docs/guide/sandbox-files", "title": "File access" },
      { "href": "/docs/guide/sandbox-snapshots", "title": "Snapshots" },
      {
        "href": "/docs/guide/sandbox-exit-snapshots",
        "title": "Exit Snapshots",
        "maturity": "beta"
      },
      {
        "href": "/docs/guide/sandbox-resources",
        "title": "Pricing and resources"
      },
      {
        "href": "/docs/guide/sandbox-sidecars",
        "title": "Sidecars",
        "maturity": "beta"
      },
      {
        "href": "/docs/guide/sandbox-secret-injection",
        "title": "Secret injection",
        "maturity": "beta"
      }
    ]
  },
  {
    "title": "Endpoints",
    "pages": [
      { "href": "/docs/guide/endpoints", "title": "Endpoints" },
      {
        "href": "/docs/guide/supported-models",
        "title": "Supported models"
      },
      {
        "href": "/docs/guide/shared-endpoints",
        "title": "Shared Endpoints"
      },
      {
        "href": "/docs/guide/dedicated-endpoints",
        "title": "Dedicated Endpoints"
      },
      {
        "href": "/docs/guide/endpoint-candidates",
        "title": "Endpoint candidates"
      },
      {
        "href": "/docs/guide/endpoint-integrations",
        "title": "Endpoint integrations"
      }
    ]
  },
  {
    "title": "Training",
    "pages": [
      {
        "href": "/docs/guide/training-quickstart",
        "title": "Quickstart"
      },
      {
        "href": "/docs/guide/spindle",
        "title": "Tinker-compatible API",
        "maturity": "beta"
      },
      {
        "href": "/docs/guide/multi-node-training",
        "title": "Multi-node training"
      }
    ]
  },
  {
    "title": "Images",
    "pages": [
      {
        "href": "/docs/guide/images",
        "title": "Defining Images"
      },
      {
        "href": "/docs/guide/existing-images",
        "title": "Using existing container images"
      },
      {
        "href": "/docs/guide/named-images",
        "title": "Named images"
      },
      {
        "href": "/docs/guide/fast-pull-from-registry",
        "title": "Fast pull from registry"
      }
    ]
  },
  {
    "title": "GPUs and other resources",
    "pages": [
      { "href": "/docs/guide/gpu", "title": "GPU acceleration" },
      { "href": "/docs/guide/cuda", "title": "Using CUDA on Modal" },
      {
        "href": "/docs/guide/resources",
        "title": "Configuring CPU, memory, and disk"
      }
    ]
  },
  {
    "title": "Scaling out",
    "pages": [
      { "href": "/docs/guide/scale", "title": "Scaling out" },
      {
        "href": "/docs/guide/concurrent-inputs",
        "title": "Input concurrency"
      },
      { "href": "/docs/guide/batch-processing", "title": "Batch processing" },
      { "href": "/docs/guide/job-queue", "title": "Job queues" },
      {
        "href": "/docs/guide/dynamic-batching",
        "title": "Dynamic batching"
      },
      {
        "href": "/docs/guide/multi-node-clusters",
        "title": "Multi-node Clusters"
      }
    ]
  },
  {
    "title": "Deployment",
    "pages": [
      {
        "href": "/docs/guide/apps",
        "title": "Apps, Functions, and entrypoints"
      },
      {
        "href": "/docs/guide/managing-deployments",
        "title": "Managing deployments"
      },
      {
        "href": "/docs/guide/continuous-deployment",
        "title": "Continuous deployment"
      },
      {
        "href": "/docs/guide/cron",
        "title": "Scheduled Functions"
      }
    ]
  },
  {
    "title": "HTTP Applications",
    "pages": [
      { "href": "/docs/guide/servers", "title": "Servers" },
      { "href": "/docs/guide/sticky-sessions", "title": "Sticky Sessions" },
      { "href": "/docs/guide/webhooks", "title": "Web Functions" },
      {
        "href": "/docs/guide/streaming-endpoints",
        "title": "Streaming endpoints"
      },
      { "href": "/docs/guide/webhook-urls", "title": "Web Function URLs" },
      { "href": "/docs/guide/webhook-timeouts", "title": "Request timeouts" },
      {
        "href": "/docs/guide/webhook-proxy-auth",
        "title": "Proxy Tokens"
      }
    ]
  },
  {
    "title": "Networking",
    "pages": [
      { "title": "Tunnels", "href": "/docs/guide/tunnels" },
      {
        "title": "Proxies",
        "href": "/docs/guide/proxy-ips",
        "maturity": "beta"
      },
      {
        "title": "Cluster networking",
        "href": "/docs/guide/private-networking"
      }
    ]
  },
  {
    "title": "Data sharing and storage",
    "pages": [
      { "href": "/docs/guide/local-data", "title": "Passing local data" },
      { "href": "/docs/guide/volumes", "title": "Volumes" },
      { "href": "/docs/guide/model-weights", "title": "Storing model weights" },
      {
        "href": "/docs/guide/cloud-bucket-mounts",
        "title": "Cloud bucket mounts"
      },
      { "href": "/docs/guide/dicts", "title": "Dicts" },
      { "href": "/docs/guide/queues", "title": "Queues" },
      {
        "href": "/docs/guide/dataset-ingestion",
        "title": "Dataset ingestion"
      }
    ]
  },
  {
    "title": "Secrets and environment variables",
    "pages": [
      { "href": "/docs/guide/secrets", "title": "Secrets" },
      {
        "href": "/docs/guide/environment_variables",
        "title": "Environment variables"
      }
    ]
  },
  {
    "title": "Performance",
    "pages": [
      { "href": "/docs/guide/cold-start", "title": "Cold start performance" },
      {
        "href": "/docs/guide/memory-snapshots",
        "title": "Memory Snapshots"
      },
      {
        "href": "/docs/guide/high-performance-llm-inference",
        "title": "High-performance LLM inference"
      }
    ]
  },
  {
    "title": "Reliability and robustness",
    "pages": [
      { "href": "/docs/guide/retries", "title": "Failures and retries" },
      { "href": "/docs/guide/preemption", "title": "Preemption" },
      { "href": "/docs/guide/timeouts", "title": "Timeouts" },
      { "href": "/docs/guide/gpu-health", "title": "GPU health" },
      { "href": "/docs/guide/troubleshooting", "title": "Troubleshooting" }
    ]
  },
  {
    "title": "Security and privacy",
    "pages": [
      { "href": "/docs/guide/security", "title": "Security and privacy" },
      { "href": "/docs/guide/data-residency", "title": "Data residency" },
      {
        "href": "/docs/guide/customer-supplied-encryption-keys",
        "title": "Customer-supplied encryption keys",
        "maturity": "alpha"
      },
      { "href": "/docs/guide/audit-logs", "title": "Audit logs" }
    ]
  },
  {
    "title": "Integrations",
    "pages": [
      {
        "href": "/docs/guide/oidc-integration",
        "title": "Using OIDC to authenticate with external services"
      },
      {
        "href": "/docs/guide/datadog-integration",
        "title": "Connecting Modal to your Datadog account"
      },
      {
        "href": "/docs/guide/otel-integration",
        "title": "Connecting Modal to your OpenTelemetry provider"
      },
      {
        "href": "/docs/guide/okta-sso",
        "title": "Okta SSO"
      },
      {
        "href": "/docs/guide/entra-sso",
        "title": "Microsoft Entra SSO"
      },
      {
        "href": "/docs/guide/saml-sso",
        "title": "Custom SAML SSO"
      },
      {
        "href": "/docs/guide/scim",
        "title": "SCIM Integration"
      },
      {
        "href": "/docs/guide/slack-notifications",
        "title": "Slack notifications",
        "maturity": "beta"
      }
    ]
  },
  {
    "title": "Workspace & account settings",
    "pages": [
      { "href": "/docs/guide/workspaces", "title": "Workspaces" },
      { "href": "/docs/guide/environments", "title": "Environments" },
      {
        "href": "/docs/guide/service-users",
        "title": "Service users"
      },
      {
        "href": "/docs/guide/user-groups",
        "title": "User groups"
      },
      {
        "href": "/docs/guide/rbac",
        "title": "Role-Based Access Control (RBAC)"
      },
      {
        "href": "/docs/guide/billing",
        "title": "Billing"
      },
      {
        "href": "/docs/guide/network-egress-billing",
        "title": "Network egress billing"
      },
      {
        "href": "/docs/guide/budgets",
        "title": "Budgets"
      }
    ]
  },
  {
    "title": "Other topics",
    "pages": [
      {
        "href": "/docs/guide/feature-maturity",
        "title": "Feature maturity"
      },
      {
        "href": "/docs/guide/restricted-access",
        "title": "Restricted Functions"
      },
      {
        "href": "/docs/guide/sdk-javascript-go",
        "title": "JavaScript/Go SDKs",
        "maturity": "beta"
      },
      {
        "href": "/docs/guide/modal-1-0-migration",
        "title": "Modal 1.0 migration guide"
      },
      {
        "href": "/docs/guide/project-structure",
        "title": "File and project structure"
      },
      {
        "href": "/docs/guide/developing-debugging",
        "title": "Developing and debugging"
      },
      { "href": "/docs/guide/jupyter-notebooks", "title": "Jupyter notebooks" },
      { "href": "/docs/guide/async", "title": "Asynchronous API usage" },
      { "href": "/docs/guide/global-variables", "title": "Global variables" },
      { "href": "/docs/guide/region-selection", "title": "Region selection" },
      {
        "href": "/docs/guide/gpu-metrics",
        "title": "GPU Metrics"
      },
      { "href": "/docs/guide/log-search-syntax", "title": "Search syntax" }
    ]
  }
]
